import React from "react";
import "./index.css";
import Navbar from "../Navbar";
import ContactModal from "../ContactModal";
import Footer from "../Footer";

const AboutPage = () => {
  return (
    <>
      <ContactModal />
      <Navbar />
      <section class="hero-section">
    <div class="hero-overlay"></div>
    <div class="hero-content">
      <h1 class="hero-title" data-aos="fade-up">Redefining Luxury Living</h1>
      <p class="hero-subtitle" data-aos="fade-up" data-aos-delay="200">
        Creating Extraordinary Spaces in Chennai's Most Prestigious Locations Since 2010
      </p>
    </div>
  </section>

  <div class="about-container">
    <header class="about-header" data-aos="fade-up">
      <h1 class="about-title">About RKhousing</h1>
      <p class="about-subtitle">Setting New Standards in Luxury Real Estate</p>
    </header>

    <div class="about-content">
      <div class="about-card" data-aos="fade-up">
        <i class="fas fa-crown card-icon"></i>
        <h2 class="card-title">Our Legacy</h2>
        <p class="card-text">
          For over a decade, RKhousing has been the epitome of luxury real estate in Chennai. 
          Our journey began with a vision to transform the city's skyline with architectural 
          masterpieces that stand as testimonials to our commitment to excellence. Each project 
          we undertake is a perfect blend of innovative design, superior craftsmanship, and 
          sustainable practices, setting new benchmarks in the industry.
        </p>
      </div>

      <div class="about-card" data-aos="fade-up" data-aos-delay="100">
        <i class="fas fa-gem card-icon"></i>
        <h2 class="card-title">Our Philosophy</h2>
        <p class="card-text">
          At RKhousing, we believe that every home tells a unique story. Our philosophy revolves 
          around creating spaces that not only meet but exceed expectations. We understand that a 
          home is more than just walls and windows – it's where life's most precious moments unfold. 
          This understanding drives us to deliver properties that are both luxurious and livable, 
          ensuring each residence is a masterpiece of comfort and elegance.
        </p>
      </div>

      <div class="about-card" data-aos="fade-up" data-aos-delay="200">
        <i class="fas fa-chart-line card-icon"></i>
        <h2 class="card-title">Our Expertise</h2>
        <p class="card-text">
          With deep roots in Chennai's real estate market, our expertise spans residential, 
          commercial, and luxury properties. Our team of seasoned professionals brings decades 
          of combined experience, ensuring that every project and transaction is handled with 
          utmost precision and care. We pride ourselves on our ability to understand and fulfill 
          our clients' unique needs, making their real estate journey seamless and rewarding.
        </p>
      </div>
    </div>

    <section class="vision-section" data-aos="fade-up">
      <div class="vision-content">
        <h2 class="vision-title">Our Vision & Values</h2>
        <div class="vision-grid">
          <div class="vision-item" data-aos="fade-up">
            <i class="fas fa-hand-holding-heart vision-icon"></i>
            <h3>Trust & Transparency</h3>
            <p>Building relationships based on honesty, integrity, and clear communication with every client.</p>
          </div>
          <div class="vision-item" data-aos="fade-up" data-aos-delay="100">
            <i class="fas fa-leaf vision-icon"></i>
            <h3>Sustainability</h3>
            <p>Committed to eco-friendly practices and sustainable development in all our projects.</p>
          </div>
          <div class="vision-item" data-aos="fade-up" data-aos-delay="200">
            <i class="fas fa-users vision-icon"></i>
            <h3>Community Focus</h3>
            <p>Creating living spaces that foster community bonds and enhance social connections.</p>
          </div>
          <div class="vision-item" data-aos="fade-up" data-aos-delay="300">
            <i class="fas fa-star vision-icon"></i>
            <h3>Excellence</h3>
            <p>Pursuing the highest standards of quality in every aspect of our developments.</p>
          </div>
        </div>
      </div>
    </section>

    {/* <section class="features-section-about">
      <header class="about-header" data-aos="fade-up">
        <h2 class="about-title">Why Choose RKhousing</h2>
        <p class="about-subtitle">Discover the RKhousing Advantage</p>
      </header>
      <div class="features-grid-about">
        <div class="feature-item-about" data-aos="fade-up">
          <i class="fas fa-building feature-icon"></i>
          <h3>Premium Locations</h3>
          <p>Strategic properties in Chennai's most sought-after neighborhoods, ensuring excellent connectivity and appreciation.</p>
        </div>
        <div class="feature-item-about" data-aos="fade-up" data-aos-delay="100">
          <i class="fas fa-paint-brush feature-icon"></i>
          <h3>Superior Design</h3>
          <p>Collaboration with renowned architects and designers to create timeless, elegant spaces.</p>
        </div>
        <div class="feature-item-about" data-aos="fade-up" data-aos-delay="200">
          <i class="fas fa-shield-alt feature-icon"></i>
          <h3>Quality Assurance</h3>
          <p>Rigorous quality control processes and use of premium materials in construction.</p>
        </div>
        <div class="feature-item-about" data-aos="fade-up" data-aos-delay="300">
          <i class="fas fa-headset feature-icon"></i>
          <h3>Customer Support</h3>
          <p>Dedicated after-sales service team ensuring a hassle-free experience for our residents.</p>
        </div>
      </div>
    </section> */}

    <section class="stats-section" data-aos="fade-up">
      <div class="stats-container">
        <div class="stat-item">
          <div class="stat-number">500+</div>
          <div class="stat-label">Properties Delivered</div>
        </div>
        <div class="stat-item">
          <div class="stat-number">1000+</div>
          <div class="stat-label">Happy Families</div>
        </div>
        <div class="stat-item">
          <div class="stat-number">15+</div>
          <div class="stat-label">Years of Excellence</div>
        </div>
        <div class="stat-item">
          <div class="stat-number">50+</div>
          <div class="stat-label">Luxury Projects</div>
        </div>
      </div>
    </section>

    <section class="projects-section">
      <header class="about-header" data-aos="fade-up">
        <h2 class="about-title">Our Signature Projects</h2>
        <p class="about-subtitle">Landmarks of Luxury in Chennai</p>
      </header>
      <div class="projects-grid">
        <div class="project-card" data-aos="fade-up">
          <img src="https://images.unsplash.com/photo-1545324418-cc1a3fa10c00?ixlib=rb-4.0.3" alt="RK Heights" class="project-image" />
          <div class="project-content">
            <h3>RK Heights</h3>
            <p>Anna Nagar</p>
            <ul class="project-features">
              <li>Premium 3 & 4 BHK Apartments</li>
              <li>World-class Amenities</li>
              <li>Smart Home Technology</li>
            </ul>
          </div>
        </div>
        <div class="project-card" data-aos="fade-up" data-aos-delay="100">
          <img src="https://images.unsplash.com/photo-1512917774080-9991f1c4c750?ixlib=rb-4.0.3" alt="RK Grande" class="project-image" />
          <div class="project-content">
            <h3>RK Grande</h3>
            <p>ECR</p>
            <ul class="project-features">
              <li>Luxury Villas</li>
              <li>Private Beach Access</li>
              <li>Resort-style Living</li>
            </ul>
          </div>
        </div>
        <div class="project-card" data-aos="fade-up" data-aos-delay="200">
          <img src="https://images.unsplash.com/photo-1486406146926-c627a92ad1ab?ixlib=rb-4.0.3" alt="RK Business Tower" class="project-image" />
          <div class="project-content">
            <h3>RK Business Tower</h3>
            <p>OMR</p>
            <ul class="project-features">
              <li>Grade A Office Spaces</li>
              <li>Green Building Certified</li>
              <li>Modern Infrastructure</li>
            </ul>
          </div>
        </div>
      </div>
    </section>

    <section class="testimonials-section">
      <header class="about-header" data-aos="fade-up">
        <h2 class="about-title">Client Testimonials</h2>
        <p class="about-subtitle">Words from Our Distinguished Clientele</p>
      </header>
      <div class="testimonial-grid">
        <div class="testimonial-card" data-aos="fade-up">
          <p class="testimonial-text">
            "RKhousing transformed our dream of owning a luxury apartment in Chennai into reality. 
            Their attention to detail, commitment to quality, and professional service exceeded 
            all our expectations. The amenities and finishing in our apartment at RK Heights 
            are truly world-class."
          </p>
          <div class="testimonial-author">
            <img src="https://randomuser.me/api/portraits/men/1.jpg" alt="Client" class="author-image" />
            <div class="author-info">
              <h4>Rajesh Kumar</h4>
              <p>RK Heights Resident</p>
            </div>
          </div>
        </div>
        <div class="testimonial-card" data-aos="fade-up" data-aos-delay="100">
          <p class="testimonial-text">
            "As an investor, I appreciate RKhousing's commitment to quality and timely delivery. 
            Their properties have shown excellent appreciation, and their after-sales service 
            is exceptional. The team's professionalism and market knowledge make them the perfect 
            choice for premium properties in Chennai."
          </p>
          <div class="testimonial-author">
            <img src="https://randomuser.me/api/portraits/women/1.jpg" alt="Client" class="author-image" />
            <div class="author-info">
              <h4>Priya Sharma</h4>
              <p>Property Investor</p>
            </div>
          </div>
        </div>
        <div class="testimonial-card" data-aos="fade-up" data-aos-delay="200">
          <p class="testimonial-text">
            "Moving into RK Grande was the best decision we made. The attention to detail in 
            design and construction is remarkable. The community here is wonderful, and the 
            amenities are beyond our expectations. RKhousing has truly delivered on their 
            promise of luxury living."
          </p>
          <div class="testimonial-author">
            <img src="https://randomuser.me/api/portraits/men/2.jpg" alt="Client" class="author-image" />
            <div class="author-info">
              <h4>Suresh Menon</h4>
              <p>RK Grande Resident</p>
            </div>
          </div>
        </div>
      </div>
    </section>

    <section class="awards-section">
      <header class="about-header" data-aos="fade-up">
        <h2 class="about-title">Our Achievements</h2>
        <p class="about-subtitle">Recognition of Our Commitment to Excellence</p>
      </header>
      <div class="awards-grid">
        <div class="award-item" data-aos="fade-up">
          <i class="fas fa-trophy award-icon"></i>
          <h3 class="award-title">Best Luxury Developer</h3>
          <p class="award-year">2023</p>
          <p class="award-desc">Awarded by Real Estate Excellence Awards</p>
        </div>
        <div class="award-item" data-aos="fade-up" data-aos-delay="100">
          <i class="fas fa-medal award-icon"></i>
          <h3 class="award-title">Customer Excellence Award</h3>
          <p class="award-year">2022</p>
          <p class="award-desc">For Outstanding Customer Service</p>
        </div>
        <div class="award-item" data-aos="fade-up" data-aos-delay="200">
          <i class="fas fa-star award-icon"></i>
          <h3 class="award-title">Real Estate Innovation Award</h3>
          <p class="award-year">2021</p>
          <p class="award-desc">For Smart Home Integration</p>
        </div>
        <div class="award-item" data-aos="fade-up" data-aos-delay="300">
          <i class="fas fa-certificate award-icon"></i>
          <h3 class="award-title">Green Building Excellence</h3>
          <p class="award-year">2023</p>
          <p class="award-desc">For Sustainable Development</p>
        </div>
      </div>
    </section>

    <section class="csr-section">
      <header class="about-header" data-aos="fade-up">
        <h2 class="about-title">Corporate Social Responsibility</h2>
        <p class="about-subtitle">Building a Better Future Together</p>
      </header>
      <div class="csr-grid">
        <div class="csr-item" data-aos="fade-up">
          <i class="fas fa-seedling csr-icon"></i>
          <h3>Environmental Initiatives</h3>
          <p>Leading green building practices and urban forest development programs in Chennai.</p>
        </div>
        <div class="csr-item" data-aos="fade-up" data-aos-delay="100">
          <i class="fas fa-graduation-cap csr-icon"></i>
          <h3>Education Support</h3>
          <p>Scholarship programs and skill development initiatives for underprivileged students.</p>
        </div>
        <div class="csr-item" data-aos="fade-up" data-aos-delay="200">
          <i class="fas fa-hands-helping csr-icon"></i>
          <h3>Community Development</h3>
          <p>Regular health camps and community welfare programs in our project localities.</p>
        </div>
      </div>
    </section>

    {/* <section class="contact-section">
      <h2 class="contact-title" data-aos="fade-up">Connect With Us</h2>
      <div class="contact-info">
        <div class="contact-item" data-aos="fade-up">
          <i class="fas fa-map-marker-alt"></i>
          <span>Corporate Office: Anna Nagar, Chennai, Tamil Nadu</span>
        </div>
        <div class="contact-item" data-aos="fade-up" data-aos-delay="100">
          <i class="fas fa-phone"></i>
          <span>Sales: +91 XXXXX XXXXX</span>
        </div>
        <div class="contact-item" data-aos="fade-up" data-aos-delay="200">
          <i class="fas fa-envelope"></i>
          <span>Email: info@rkhousing.com</span>
        </div>
        <div class="contact-item" data-aos="fade-up" data-aos-delay="300">
          <i class="fas fa-clock"></i>
          <span>Working Hours: Mon-Sat (9:00 AM - 6:00 PM)</span>
        </div>
      </div>
    </section> */}
  </div>

      <Footer />
    </>
  );
};

export default AboutPage;